module.exports = __webpack_public_path__ + "static/media/sss-auto-logo.44e45ad5.png";